import React from "react";

import { SkeletonGenerator } from "@ui/Atoms";

import { StyledContainer } from "./steps/UrssafRegistrationForm/UrssafRegistrationForm";

const PageSkeleton = React.memo(() => (
  <StyledContainer>
    <SkeletonGenerator count={1} shape={"rectVertical"} />
    <SkeletonGenerator count={3} shape={"rectVertical"} noGutter />
    <SkeletonGenerator count={1} shape={"rectVertical"} />
    <SkeletonGenerator count={1} shape={"rectVertical"} />
  </StyledContainer>
));

PageSkeleton.displayName = "PageSkeleton";

export { PageSkeleton };
